import { TextField } from "@mui/material";
import { StandardTextFieldProps } from "@mui/material/TextField";
import * as React from "react";
import { makeStyles } from "tss-react/mui";
import { InputColorClasses, InputColorClassKeys } from "./styles/InputColorClasses";

const useStyles = makeStyles<void, InputColorClassKeys>()(
    (theme, p, classes) => ({
        ...InputColorClasses(theme)
    })
);

interface IProps extends Omit<StandardTextFieldProps, "InputProps"> {
    maxLength?: number;
    inputColor?: MprcColorsExtended,
    underlineColor?: MprcColorsExtended,
    startAdornment?: React.ReactNode;
    endAdornment?: React.ReactNode;
    onEnter?: () => void;
    onEscape?: () => void;
}

export const MprcTextFieldColor: React.FC<IProps> = (props) => {
    const { inputColor, maxLength, underlineColor, startAdornment, endAdornment, onEnter, onEscape, ...rest } = props;
    const { classes } = useStyles();

    return (
        <TextField
            {...rest}
            slotProps={{
                input: {
                    classes: {
                        root: inputColor ? classes["root_" + inputColor as InputColorClassKeys] : undefined,
                        underline: underlineColor ? classes.under + " " + classes["under_" + underlineColor as InputColorClassKeys] : undefined
                    },
                    startAdornment: startAdornment,
                    endAdornment: endAdornment,
                    onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.keyCode == 13 && onEnter) onEnter();
                        if (e.keyCode == 27 && onEscape) onEscape();
                    },
                    inputProps: { maxLength: maxLength }
                }
            }}
        />
    );
};
